export default __webpack_public_path__ + "static/media/xbox-3.c3d82ec7.png";